import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Checkmark from '../../../assets/svg/Checkmark';

import colors from '../../../styling/colors';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

import HandOffLink from '../../../utils/urls/HandOffLink';
import { toggleQueryParameter } from '../../../utils/urls/urlGenerator';

import { trackToggleFilter } from '../../../redux/filters.tracking';
import TrackingContext from '../../../tracking/TrackingContext';

const SwatchContainer = styled(HandOffLink)`
  background-color: ${({ color }) => '#' + color};
  // TODO: Can we generate a gradient instead of making a file request?
  ${({ isMetallic, colorName }) =>
    isMetallic
      ? `
        background-image: url("//p.ppassets.com/images/papers/colors/color_${colorName}.jpg");
        background-size: 100%;
      `
      : ``}
  box-sizing: border-box;
  border: 1px solid ${colors('gallery')};
  border-radius: 100%;
  width: 2.75rem;
  height: 2.75rem;
  margin: 0 0.75rem 1.25rem 0;
  cursor: pointer;

  &:nth-child(5n) {
    margin-right: 0;
  }

  @media (min-width: 23rem) {
    margin-right: 1.25rem;
  }

  @media (min-width: 48rem) {
    margin-right: 2rem;
  }

  @media (${DESKTOP_START_QUERY}) {
    height: 2rem;
    width: 2rem;
    margin: 0 0.5rem 0.5rem 0;

    &:hover {
      opacity: 0.5;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }

    &:last-child {
      margin-bottom: 1.5rem;
    }
  }
`;

const CheckmarkContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const FilterSwatch = ({ on, rgb, type, value, trackToggleFilter }) => {
  const route = useRouter();
  const { filterSelectionType } = useContext(TrackingContext);

  const isMetallic =
    value === 'gold' || value === 'silver' || value === 'rosegold';

  const hrefValue = { query: { page: 1 } };
  hrefValue.query[type] = toggleQueryParameter(value, route.query[type]);

  const trackingCallback = () =>
    trackToggleFilter(type, value, !on, filterSelectionType);

  return (
    <SwatchContainer
      color={rgb}
      colorName={value}
      isMetallic={isMetallic}
      href={hrefValue}
      preRedirects={[trackingCallback]}
      scroll={false}
      preventLinkTracking
    >
      <CheckmarkContainer>
        <Checkmark
          width={on ? '2rem' : '0'}
          height="2rem"
          strokeColor={rgb === 'ffffff' ? 'black' : 'white'}
        />
      </CheckmarkContainer>
    </SwatchContainer>
  );
};

FilterSwatch.propTypes = {
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  rgb: PropTypes.string.isRequired,
  on: PropTypes.bool.isRequired,
};

const mapDispatchToProps = { trackToggleFilter };

export default connect(null, mapDispatchToProps)(React.memo(FilterSwatch));
